export default __webpack_public_path__ + "static/internet-of-things-iot-applications-development-company-peerbits-9dec7db56569fcde1836ec6d3330d319.png";